import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpCurrencyPhysicalUnitSelector
     * @memberof app
     *
     * @restrict E
     * @scope {}
     *
     * @description
     * A price field with two dropdowns to select the currency and physical unit part of the price.
     *
     * @param {app.PriceUnitDto[]} possibleCurrencies
     * @param {string[]} possiblePhysicalUnits
     *
     * @attr {expression} required Evaluates to `true` if the value is required, `false` otherwise.
     * @attr {expression} name The name of to give the input field.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive(
            'pkpCurrencyPhysicalUnitSelector',
            pkpCurrencyPhysicalUnitSelector
        );

    function pkpCurrencyPhysicalUnitSelector() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                placeholder: '@',
                possibleCurrencies: '=',
                possiblePhysicalUnits: '=',
                possibleRuntimes: '=',
                setSelectedCurrency: '=',
                separateFields: '=',
                preSelectedPhysicalUnit: '=',
                preSelectedRuntime: '='
            },
            template:
                require('app/_directives/pkp-currency-physical-unit-selector.directive.html'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            scope.updatePrice = updatePrice;
            scope.updateUnit = updateUnit;
            scope.updateRuntime = updateRuntime;
            scope.required = attr.required;
            scope.minLength = attr.minLength;
            scope.minLengthError = attr.minLengthError;
            scope.maxLength = attr.maxLength;
            scope.maxLengthError = attr.maxLengthError;
            scope.name = attr.name;
            scope.selectedCurrency = null;
            scope.selectedPhysicalUnit = null;
            scope.selectedRuntime = null;
            scope.price = null;

            ngModelCtrl.$formatters.push(convertToViewValue);
            ngModelCtrl.$parsers.push(convertToModelValue);

            var unbindCurrencyWatcher = scope.$watch(
                function () {
                    return scope.possibleCurrencies;
                },
                function (newCurrencies) {
                    if (!newCurrencies) {
                        return;
                    }
                    if (!scope.separateFields) {
                        scope.selectedCurrency = newCurrencies[0];
                        scope.selectedPhysicalUnit =
                            newCurrencies[0].physicalUnit;
                    } else {
                        scope.selectedCurrency = newCurrencies[0];
                        if (!scope.selectedPhysicalUnit) {
                            scope.selectedPhysicalUnit =
                                scope.preSelectedPhysicalUnit;
                        }
                        if (!scope.selectedRuntime) {
                            scope.selectedRuntime = scope.preSelectedRuntime;
                        }
                    }

                    unbindCurrencyWatcher();
                }
            );

            /**
             * Set the `ngModel`'s `viewValue` by taking.
             *
             * @memberof app.pkpCurrencyPhysicalUnitSelector
             */
            function updatePrice() {
                if (!angular.isUndefined(scope.price)) {
                    if (scope.price == null) {
                        ngModelCtrl.$setViewValue(null);
                    } else {
                        ngModelCtrl.$setViewValue(scope.price.value);
                    }
                }
            }

            /**
             * @memberof app.pkpCurrencyPhysicalUnitSelector
             * @param {string} newValue The new currency or physical unit.
             * @param {boolean} isCurrency `true` if the currency should be update, otherwise for the physical unit.
             * @returns {void}
             */
            function updateUnit(newValue, isCurrency) {
                if (isCurrency) {
                    scope.selectedCurrency = newValue;
                } else {
                    scope.selectedPhysicalUnit = newValue;
                }

                if (ngModelCtrl.$modelValue) {
                    ngModelCtrl.$modelValue.originalUnit =
                        scope.selectedCurrency;
                    ngModelCtrl.$modelValue.originalUnit.physicalUnit =
                        scope.selectedPhysicalUnit;
                }
            }

            function updateRuntime(newValue) {
                scope.selectedRuntime = newValue;

                if (ngModelCtrl.$modelValue) {
                    ngModelCtrl.$modelValue.originalUnit.periodType =
                        scope.selectedRuntime === 'RUNTIME'
                            ? undefined
                            : scope.selectedRuntime;
                    if (scope.selectedRuntime == 'RUNTIME') {
                        ngModelCtrl.$modelValue.originalUnit.unspecificPeriod = true;
                    } else {
                        ngModelCtrl.$modelValue.originalUnit.unspecificPeriod = false;
                    }
                }
            }

            /**
             * @memberof app.pkpCurrencyPhysicalUnitSelector
             * @param {string} viewValue The view value that is displayed to the user.
             * @returns {Object}
             */
            function convertToModelValue(viewValue) {
                var modelValue = {
                    originalValue: {
                        value: viewValue,
                        floatingPointNumber: true
                    },
                    originalUnit: scope.selectedCurrency
                };
                modelValue.originalUnit.physicalUnit =
                    scope.selectedPhysicalUnit;
                modelValue.originalUnit.periodType =
                    scope.selectedRuntime === 'RUNTIME'
                        ? undefined
                        : scope.selectedRuntime;
                modelValue.originalUnit.unspecificPeriod =
                    scope.selectedRuntime === 'RUNTIME';
                return modelValue;
            }

            /**
             * @memberof app.pkpCurrencyPhysicalUnitSelector
             * @param {Object} modelValue The model value.
             * @returns {string|undefined} The value the user will see in the input field.
             */
            function convertToViewValue(modelValue) {
                if (!modelValue || !modelValue.originalValue) {
                    scope.price = null;
                    return;
                }
                scope.price = { value: modelValue.originalValue.value };
                scope.selectedCurrency = modelValue.originalUnit;
                scope.selectedPhysicalUnit =
                    modelValue.originalUnit.physicalUnit;
                scope.selectedRuntime = modelValue.originalUnit.periodType;
                return modelValue.originalValue.value;
            }
        }
    }
})();
